namespace GeniuzPOS.InitialData {
    export interface VexchangeRow {
        Id?: number;
        CurrencyCode?: string;
        EffectiveDate?: string;
        ExchangeRate?: number;
    }

    export namespace VexchangeRow {
        export const idProperty = 'CurrencyCode';
        export const nameProperty = 'CurrencyCode';
        export const localTextPrefix = 'InitialData.Vexchange';
        export const lookupKey = 'InitialData.Vexchange';

        export function getLookup(): Q.Lookup<VexchangeRow> {
            return Q.getLookup<VexchangeRow>('InitialData.Vexchange');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            CurrencyCode = "CurrencyCode",
            EffectiveDate = "EffectiveDate",
            ExchangeRate = "ExchangeRate"
        }
    }
}
